import React from 'react';
import { NavLink } from 'react-router-dom';
import { User, Building2 } from 'lucide-react';

const UserAvatar = ({user}) => {
  return (
    <NavLink to="/profile" className="user-avatar">
      <div className="avatar-icon">
        <User size={20} />
      </div>
      <span className="username">{user.username.length > 1 ? user.username : `${user.firstname} ${user.lastname}`}</span>
    </NavLink>
  );
};

export default UserAvatar; 